/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BankTransferDTO } from './BankTransferDTO';
import type { MomoDTO } from './MomoDTO';
import type { OutBankTransferDTO } from './OutBankTransferDTO';
import type { PayerAccountRecord } from './PayerAccountRecord';
import type { PaymentLinkDTO } from './PaymentLinkDTO';
import type { QrCodeDTO } from './QrCodeDTO';
import type { RefundBankTransferDTO } from './RefundBankTransferDTO';
import type { SaleItemDTO } from './SaleItemDTO';
import type { UssdDTO } from './UssdDTO';

/**
 * Class that defines all the properties of a operation
 */
export type OperationFullDTO = {
    /**
     * Indicates if the operation can be disputed
     */
    canBeDisputed?: boolean;
    /**
     * Indicates if the operation can be refunded
     */
    canBeRefunded?: boolean;
    /**
     * Indicates the name of the user who initiated the operation
     */
    collectedBy?: string;
    /**
     * Creation date
     */
    createdAt?: string;
    /**
     * Currency of the operation
     */
    currency?: string;
    /**
     * Indicates what device was used to create this operation
     */
    deviceChannel?: OperationFullDTO.deviceChannel;
    inBankTransfer?: BankTransferDTO;
    momo?: MomoDTO;
    /**
     * Id of this operation
     */
    operationId?: string;
    /**
     * Indicates if the money is flowing IN or OUT of the merchant account
     */
    operationType?: OperationFullDTO.operationType;
    outBankTransfer?: OutBankTransferDTO;
    payerAccount?: PayerAccountRecord;
    paymentLink?: PaymentLinkDTO;
    /**
     * Payment method of the operation
     */
    paymentMethod?: OperationFullDTO.paymentMethod;
    qrcode?: QrCodeDTO;
    /**
     * Indicates the receipt number of this operation
     */
    receiptNumber?: number;
    refund?: RefundBankTransferDTO;
    /**
     * Indicates what amount was previously refunded
     */
    refundedAmount?: number;
    /**
     * Sale items associated with this operation
     */
    saleItemDetail?: Array<SaleItemDTO>;
    /**
     * Indicates the sessionId of the transaction
     */
    sessionId?: string;
    /**
     * Indicates the status of the operation
     */
    status?: OperationFullDTO.status;
    /**
     * Indicates the total amount of the operation (includes fee)
     */
    totalAmount?: number;
    /**
     * Indicates the transaction id saved in external service
     */
    transactionId?: string;
    /**
     * Indicates the virtual account number the transaction was paid to
     */
    transferAccount?: string;
    /**
     * Date that operation was finished
     */
    updatedAt?: string;
    ussd?: UssdDTO;
};

export namespace OperationFullDTO {

    /**
     * Indicates what device was used to create this operation
     */
    export enum deviceChannel {
        WEB = 'WEB',
        POS = 'POS',
        MOBILE = 'MOBILE',
    }

    /**
     * Indicates if the money is flowing IN or OUT of the merchant account
     */
    export enum operationType {
        IN = 'IN',
        OUT = 'OUT',
    }

    /**
     * Payment method of the operation
     */
    export enum paymentMethod {
        CASH = 'CASH',
        POS = 'POS',
        POS_ORDER = 'POS_ORDER',
        USSD = 'USSD',
        QR_CODE = 'QR_CODE',
        IN_BANK_TRANSFER = 'IN_BANK_TRANSFER',
        INWARDS_TRANSFER = 'INWARDS_TRANSFER',
        PAY_WITH_TRANSFER = 'PAY_WITH_TRANSFER',
        PAYMENT_LINK_PAY_WITH_TRANSFER = 'PAYMENT_LINK_PAY_WITH_TRANSFER',
        PAYMENT_LINK_USSD = 'PAYMENT_LINK_USSD',
        PAYMENT_LINK_CARD = 'PAYMENT_LINK_CARD',
        PAYMENT_LINK_QR_CODE = 'PAYMENT_LINK_QR_CODE',
        MOMO = 'MOMO',
        PAYMENT_LINK = 'PAYMENT_LINK',
        OUT_BANK_TRANSFER = 'OUT_BANK_TRANSFER',
        REFUND = 'REFUND',
        CARD = 'CARD',
    }

    /**
     * Indicates the status of the operation
     */
    export enum status {
        SUCCESS = 'SUCCESS',
        EXPIRED = 'EXPIRED',
        PENDING = 'PENDING',
        DECLINED = 'DECLINED',
        FAILED = 'FAILED',
    }
}